module.exports = __webpack_public_path__ + "static/media/discord-icon.4e18a4e6.svg";